<template>
  <div class="invoice">
    <h1>发票,功能开发中...</h1>
  </div>
</template>

<script>

export default {
  name: 'Invoice',
  mixins: [],
  components: {},
  props: {},
  data () {
    return {
      aaaa: '12312321'
    }
  },
  computed: {},
  watch: {},
  created () {},
  mounted () {},
  destroyed () {},
  methods: {},
}
</script>

<style scoped lang="scss">

</style>